import api from '@/api/axios';
import Auth  from '@/utils/auth';

export default {
	async logout({ commit }) {
		try {
			Auth.logout();
			commit('unsetUser');
		} catch (err) {
			//
		}
	},
	async getInfo({ commit }) {
		try {
			const user = await api.get('/general/current');
			commit('setUser', user.data);
		}
		catch (e) {
			//
		}
	}
};
